export const GET_UNSEEN_NOTIFICATIONS = 'GET_UNSEEN_NOTIFICATIONS';
export const REQUEST_UNSEEN_NOTIFICATIONS = 'REQUEST_UNSEEN_NOTIFICATIONS';
export const REQUEST_ONE_NOTIFICATION = 'REQUEST_ONE_NOTIFICATION';
export const GET_ONE_NOTIFICATION = 'GET_ONE_NOTIFICATION';
export const GET_NOTIFICATION_FAILURE = 'NOTIFICATION_FAILURE';
export const REQUEST_ALL_NOTIFICATIONS = 'REQUEST_ALL_NOTIFICATIONS';
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS';
export const ALL_NOTIFICATIONS_FAILED = 'ALL_NOTIFICATIONS_FAILED';
